import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export const RefundBuyerSellerMeetingFee = createAsyncThunk(
    'engagementMeetings/refundBuyerSellerMeetingFee',
    async (
        {
            engagementId,
            proposalId,
            buyerId,
            reason,
        }: {
            engagementId: number;
            proposalId: string;
            buyerId: number;
            reason: string;
        },
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        const response = await axios.post(
            '/api/MarketplaceCommerce/MeetingFeeRefund',
            {
                engagementId,
                proposalId,
                buyerId,
                proRata: false,
                reason,
            }
        );

        if (response.status !== 200 && response.status !== 204) {
            createNotification('Could not process refund at the moment.', 'error');
            throw new Error('Failed to process refund');
        }

        createNotification('Meeting cancelled and refund issued successfully.', 'success');
        return { engagementId, proposalId };
    }
);
